export default __webpack_public_path__ + "static/banff-canada-by-J@M-LaFlamme-8627bc7370fb05ddfe8a99f1b6c5d032.jpg";